import React from 'react';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';

const SupplyAndDemandChart = ({ chartData }) => {
    const chartOptions = {
        chart: {
            type: 'line',
            toolbar: {
                show: false
            },
            sparkline: {
                enabled: true
            }
        },
        stroke: {
            width: 3,
            curve: 'straight'
        },
        colors: ['#236847'],
        tooltip: {
            enabled: false
        },
        legend: {
            show: false
        }
    };

    const values = chartData.msiValues || chartData.avgDomValues || [];

    const chartSeries = [
        {
            name: 'Value',
            data: values
        }
    ];

    return (
        <Chart
            options={chartOptions}
            series={chartSeries}
            type="line"
            width="100%"
            height="60px"
        />
    );
};

SupplyAndDemandChart.propTypes = {
    chartData: PropTypes.shape({
        msiValues: PropTypes.arrayOf(PropTypes.number),
        avgDomValues: PropTypes.arrayOf(PropTypes.number)
    }).isRequired,
};

export default SupplyAndDemandChart;
